import { isNativeApp } from "@/platform";
import { useAuth } from "@/models/useAuth";
import { Navigate } from "@/router";
import { desktop } from "@/controller";
import { hasAccountIdentity } from "@/auth-identity";

function IndexPage() {
  const destination = desktop.isAvailable
    ? hasAccountIdentity(useAuth.currentAuthUser())
      ? "/home"
      : "/desktop-sign-in"
    : isNativeApp() || useAuth.isAuthenticated()
      ? "/home"
      : "/auth";
  return <Navigate to={destination} replace />;
}

export default IndexPage;
